<template>
  <!--
      	作者：kmdshop
      	时间：2019-06-04
      	描述：插件中心-优惠券-优惠券列表
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="">
          <el-input v-model="formInline.search" placeholder="请输入产品SkuID"></el-input>
        </el-form-item>
        <el-form-item label="">
            <el-select v-model="formInline.status" @change="onSubmit" placeholder="请选择">
              <el-option label="未核销" :value="0">
              </el-option>
              <el-option label="已核销" :value="1">
              </el-option>
              <el-option label="全部" value="" >
              </el-option>
            </el-select>
          </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="approve_log_id" label="ID" width="100"></el-table-column>
            <el-table-column prop="rel_val.product_sku_id" label="产品Sku_id" width="100"></el-table-column>
            <el-table-column prop="rel_val.product_name" label="产品名称" width="100"></el-table-column>
            <el-table-column prop="num" label="报销数量"></el-table-column>
            <el-table-column prop="actual_num" label="实际报销数量"></el-table-column>
            <el-table-column prop="apply_user" label="申请人"></el-table-column>
            <el-table-column prop="audit_user" label="报销人"></el-table-column>
            <el-table-column prop="actual_audit_user" label="最终报销人"></el-table-column>
            <el-table-column prop="create_time" label="申请时间" width="135"></el-table-column>
            <el-table-column prop="update_time" label="报销时间" width="135"></el-table-column>
            <el-table-column prop="status" label="状态" width="135">
              <template slot-scope="scope">
                <div v-if="scope.row.status == 0">待报销</div>
                <div v-if="scope.row.status == 1">已报销</div>
                <div v-if="scope.row.status == 2">已驳回</div>
                <div v-if="scope.row.status == 3">还未提交报销</div>
              </template>

            </el-table-column>
            <el-table-column prop="reject_reason" label="驳回理由" width="135"></el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import ExpensesApi from '@/api/expenses.js';
  export default {
    data() {
      return {
        formInline: {
          product_sku_id:"",
          search:""
        },
        form: {},
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*是否加载完成*/
        loading: true,
      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {
      onSubmit(){
        this.getData();
      },
      /*获取列表*/
      getData() {
        let self = this;
        let Params = {};
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.code = "expenses"
        ExpensesApi.getExpensesRecord(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total
          })
          .catch(error => {});
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getData();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/expenses/sold/index.vue